export default __webpack_public_path__ + "static/media/5b12d0b2a5b54b658be3aff3d690dfbf.8090beea.png";